import { Button, Spinner } from '@blend-ed/blendx-ui';
import PropTypes from 'prop-types';
import { useCallback } from 'react';
import { injectIntl, intlShape } from '@edx/frontend-platform/i18n';
import intlMessages from '../../messages';

function WelcomeScreen({ isLoading, handleSendMessage, suggestedQuestions, suggestedTopics, intl }) {
  console.log("suggestedTopics", suggestedTopics);
  console.log("suggestedQuestions", suggestedQuestions);
  console.log("isLoading", isLoading);

  if (isLoading) {
    return <div className="ai-tutor__loading">
      <Spinner animation="border" size="lg" variant="dark" />
    </div>
  }

  const suggestionsClickHandler = useCallback((starterText) => {
    handleSendMessage(starterText);
  }, [handleSendMessage]);

  return (
    <>
      <div className="ai-tutor__welcome">
        <h4 className="mb-2">{intl.formatMessage(intlMessages.welcome)}</h4>
        <p className="mb-2">{intl.formatMessage(intlMessages.welcomeDescription)}</p>
        <div className="ai-tutor__topics">
          {suggestedTopics.map((topic) => (
            <Button
              key={topic}
              variant="outline-gray"
              size="xs"
              onClick={() => suggestionsClickHandler(topic)}
            >
              {topic}
            </Button>
          ))}
        </div>
      </div>
      <div className="ai-tutor__suggested-questions">
        <h4 className="mb-2">{intl.formatMessage(intlMessages.suggestedQuestions)}</h4>
        <ul>
          {suggestedQuestions.map((item) => (
            <li key={item} className="mb-0">
              <Button
                variant="link"
                size="xs"
                className="px-0 py-0"
                onClick={() => suggestionsClickHandler(item)}
              >
                {item}
              </Button>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
}

WelcomeScreen.propTypes = {
  handleSendMessage: PropTypes.func.isRequired,
  suggestedQuestions: PropTypes.array.isRequired,
  suggestedTopics: PropTypes.array.isRequired,
  isLoading: PropTypes.bool.isRequired,
  intl: intlShape.isRequired,
};

export default injectIntl(WelcomeScreen); 